import polledUiSchema from './polled/uiSchema'

const schemas: any = {
  'gateway:input:polled': {
    ui: polledUiSchema,
  },
}

export default schemas
